import http from "../http-common";

class ProjectFileDataService {
  getAll() {
    return http.get("/projectfile");
  }

  get(id) {
    return http.get(`/projectfile/${id}`);
  }

  getByProject(id) {
    return http.get(`/projectfile/getByProject/${id}`);
  }

  create(data) {
    if(data.file)
    data.fileName = data.file.name;
    else
    data.fileName = "";
    return http.post("/projectfile", data);
  }

  update(id, data) {
    if(data.file)
    data.fileName = data.file.name;
    else
    data.fileName = "";
    return http.put(`/projectfile/${id}`, data);
  }

  delete(id) {
    return http.delete(`/projectfile/${id}`,);
  }

  deleteAll() {
    return http.delete(`/projectfile`, );
  }

  findByTitle(title) {
    return http.get(`/projectfile?title=${title}`,);
  }

  cloneProject(data) {
    return http.post("/projectfile/clone", data);
  }

}

export default new ProjectFileDataService();